<template>
  <span>
    {{chosenAnswer.text}}
  </span>
</template>

<script>
export default {
  name: "Word",
  props: {
    word: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chosenAnswer() {
      if(!this.word.answers) {
        return { text: '' };
      }
      return this.word.answers.find(a => a.used === 1) || this.word.answers[0];
    },
  }
}
</script>